const closeButton = "_086cvt0j3y";

export { closeButton };
import "./tool.fullscreen.style.linaria.module.css";
//# sourceMappingURL=tool.fullscreen.style.js.map
